import React, { useState , useEffect} from 'react'
import { useParams } from 'react-router-dom'
import {
	Header,
} from '../../componentsRef'
import {Spinner} from '../../componentsRef/ui'
import {LogoutPopup} from '../LogoutPopup'
import TableauReport from 'tableau-react'
import {envVariables} from '../../utils/envVariables/envVariables'
import {getAccessToken} from '../../utils/authSession'

const buildProductTableauUrl = () => {
	const baseUrl = envVariables.tableauServerBaseUrl?.replace(/\/$/, '')
	const site = envVariables.tableauSite
	const productView = envVariables.tableauViews.vistaproducto

	if (!baseUrl || !site || !productView) return ''

	return `${baseUrl}/t/${site}/views/${productView}`
}

const getMissingProductConfig = () => {
	const requiredConfig = [
		['REACT_APP_TABLEAU_SERVER_BASE_URL', envVariables.tableauServerBaseUrl],
		['REACT_APP_TABLEAU_SITE', envVariables.tableauSite],
		['REACT_APP_TABLEAU_TRUST_URL', envVariables.tableauTrustUrl],
		['REACT_APP_TABLEAU_PRODUCT_PROJECT', envVariables.tableauProductProject],
		['REACT_APP_TABLEAU_PRODUCT_PAGE', envVariables.tableauProductPage],
		['REACT_APP_TABLEAU_VIEW_VISTA_PRODUCTO', envVariables.tableauViews.vistaproducto],
	]

	return requiredConfig.filter(([, value]) => !value).map(([key]) => key)
}

export const DashboardClean = () => {
    const [tokenTableau, setTokenTableau] = useState()
	const [tableauError, setTableauError] = useState('')
	const [LogoutState, setLogoutState] = useState(false)
    const { codigoProducto, cadena } = useParams()
	const url_ = buildProductTableauUrl()
	const missingConfig = getMissingProductConfig()
    let parameters_ = {}
    parameters_ = {
        "Codigo Producto": [codigoProducto], 
        "cadena": [cadena]
    }
		
	
	/*
            parameters_ = {
			ID1: [dataProduct.code_product + '-' + data.cadena_details.name_customer],
		}
    */
	const fetchApi = async () => {
		if (missingConfig.length) {
			setTableauError(`Configuración de Tableau incompleta. Faltan: ${missingConfig.join(', ')}`)
			return
		}

		try {
			const response = await fetch(envVariables.tableauTrustUrl, {
				method: 'POST',
				body: JSON.stringify({
					token: getAccessToken() + '-2chzRY3F3I9@',
					tabs_permission: envVariables.tableauTabsPermission,
					dtarget_site: envVariables.tableauSite,
					project: envVariables.tableauProductProject,
					page: envVariables.tableauProductPage,
				}),
			})

			console.log(response.status)
			const responseJSON = await response.json()
			setTokenTableau(responseJSON.token_server)
		} catch (error) {
			console.error(error)
			setTableauError('No fue posible cargar la configuración de Tableau.')
		}
	}

    useEffect(() => {
		fetchApi()
    }, [codigoProducto, cadena])

	return (
        <>
			{LogoutState && <LogoutPopup setLogoutState={setLogoutState} />}
            
			{tableauError ? (
				<div style={{padding: '24px', color: '#474747'}}>{tableauError}</div>
			) : !tokenTableau ? (
				<Spinner />
			) : (
				<TableauReport
					url={url_}
					token={tokenTableau}
					options={{
						// width: "100%",
						width: "600px",
						height: "100vh",
					}}
					query="?:jsdebug=n"
					parameters={parameters_}
				/>
			)}
            </>
	)
}
